import React from "react";
import WhiteLogo from '../assets/images/whiteLogo.svg';
import { Link } from "react-router-dom";

const Footer=()=>{
    return(
        <>
        <div className="footer">
            <div className="container">
                <div className="row">
                    <div className="col-xs-12 col-md-3">
                        <div className="abtPrandot">
                            <img src={WhiteLogo} />
                            <p>India’s digital command center for health. Integrating data, technology, and humanity for a healthier nation.</p>
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-7 offset-md-2">
                        <div className="row">
                            <div className="col-xs-12 col-md-4">
                                <div className="footerLinks">
                                    <h5>Quick Links</h5>
                                    <ul>
                                        <li><a href="#">Why Pran AI</a></li>
                                        <li><a href="#">Products</a></li>
                                        <li><a href="#">Partnerships</a></li>
                                        <li><a href="#">Team</a></li>
                                        <li><a href="#">Contact Us</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-4">
                                <div className="footerLinks">
                                    <h5>Modules</h5>
                                    <ul>
                                        <li><a href="#">Govt Dashboard</a></li>
                                        <li><a href="#">Hospital Admin</a></li>
                                        <li><a href="#">ABHA Integration</a></li>
                                        <li><a href="#">Patients App</a></li>
                                        <li><a href="#">HMIS & LIMS</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-4">
                                <div className="footerLinks">
                                    <h5>Contact Us</h5>
                                    <ul>
                                        <li>Tech Park, Sector 18, Gurugram, Haryana, India</li>
                                        <li>+91 11 2345 6789</li>
                                        <li>contact@pran.ai</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="lastFooter">
                    <p>© 2025 Pran AI LLC. All rights reserved.</p>
                    <p><Link to="/privacy-policy">Privacy Policy</Link> | <Link to="/terms-of-service">Terms of Service</Link> | <Link to="/cookie-policy">Cookie Policy</Link></p>
                </div>
            </div>
        </div>
        </>
    )
}

export default Footer;